export enum LogisticContractReferenceType {
  InvoiceNumber = 'InvoiceNumber',
  MarketplaceOrderNumber = 'MarketplaceOrderNumber',
  BuyerMarketplaceAccount = 'BuyerMarketplaceAccount',
  AccountName = 'AccountName',
  CustomerNumber = 'CustomerNumber',
  HandleByTime = 'HandleByTime',
  ExternalNote = 'ExternalNote',
}
